type LogoSize = "sm" | "md" | "lg";

const HEIGHT_CLASS: Record<LogoSize, string> = {
  sm: "h-7",
  md: "h-9",
  lg: "h-12",
};

export function Logo({ size = "md", className = "" }: { size?: LogoSize; className?: string }) {
  return (
    <img
      src="/assets/logo.png"
      alt="VirtualDesk"
      width={256}
      height={176}
      className={`${HEIGHT_CLASS[size]} w-auto ${className}`.trim()}
    />
  );
}
